import Base from '../../_config/base';

class Projektdetail extends Base {
  constructor(el) {
    super(el);
    const galery = el.querySelector('#galery');
    const lightswitches = el.querySelector('.projektdetail__options');
    const lightswitchesCopy = el.querySelector('.projektdetail__options__copy');
    const lightswitchcontent = el.querySelectorAll('.lightswitchcontent');
    const showAll = el.querySelectorAll('.projektdetail__morebuttons__showmore');

    // Initial state setup
    if (lightswitchcontent !== null) {
      for (let i = 0; i < lightswitchcontent.length; i += 1) {
        if (i === 0) {
          lightswitchcontent[i].classList.add('projektdetail__galery-active');
        } else {
          lightswitchcontent[i].classList.add('projektdetail__galery-inactive');
        }
      }
    }
    if (lightswitches !== null) {
      lightswitches.children[0].classList.add('projektdetail__options__items-active');
      if (lightswitchesCopy !== null) {
        lightswitchesCopy.append(lightswitches.cloneNode(true));
      }
    }
    const lightswitch1 = el.querySelectorAll('.lightswitch1');
    const lightswitch2 = el.querySelectorAll('.lightswitch2');
    const statsButton = el.querySelectorAll('.statsButton');

    // toggle classes
    const toggleLightSwitch = () => {
      if (lightswitch1 !== null) {
        lightswitch1.forEach((item) => {
          item.classList.toggle('projektdetail__options__items-active');
        });
      }
      if (lightswitch2 !== null) {
        lightswitch2.forEach((item) => {
          item.classList.toggle('projektdetail__options__items-active');
        });
      }
      if (lightswitchcontent !== null) {
        lightswitchcontent.forEach((item) => {
          item.classList.toggle('projektdetail__galery-active');
          item.classList.toggle('projektdetail__galery-inactive');
        });
      }
    };

    const scrollToTopOfGalery = () => {
      setTimeout(() => {
        window.scrollTo({
          top: galery.offsetTop - 64,
          behavior: 'smooth',
        });
      }, 100);
    };

    // scroll to stats section
    if (statsButton !== null) {
      statsButton.forEach((item) => {
        item.onclick = () => {
          window.scrollTo({
            top: el.querySelector('#stats').offsetTop - 64,
            behavior: 'smooth',
          });
        };
      });
    }

    if (lightswitch1 !== null) {
      lightswitch1.forEach((item) => {
        item.onclick = () => {
          if (!item.classList.contains('projektdetail__options__items-active')) {
            toggleLightSwitch();
          }
          scrollToTopOfGalery();
        };
      });
    }

    if (lightswitch2 !== null) {
      lightswitch2.forEach((item) => {
        item.onclick = () => {
          if (!item.classList.contains('projektdetail__options__items-active')) {
            toggleLightSwitch();
          }
          scrollToTopOfGalery();
        };
      });
    }

    if (showAll !== null) {
      showAll.forEach((item) => {
        const parent = item.parentElement.parentElement;
        const allItems = [...parent.querySelectorAll('.projektdetail__impressions__item, .projektdetail__plaene__item')];
        item.onclick = () => {
          item.parentElement.remove();
          allItems.forEach((elItem) => {
            elItem.classList.remove('projektdetail__galery__hidden');
          });
        };
      });
    }
  }
}

Projektdetail.className = 'Projektdetail';
export default Projektdetail;
